(function (angular) {
    'use strict';

    angular.module('shared')
        .factory("uploadFileService", ['$q', '$uibModal', function ($q, $uibModal) {

            return ({
                uploadFile: uploadFile,
                uploadGlobalFile: uploadGlobalFile,
                uploadCustomFile: uploadCustomFile,
                uploadGlobalCustomFile: uploadGlobalCustomFile
            });
            function uploadGlobalFile(folder, supportedContentTypes, options){
                return uploadFile(folder, true, supportedContentTypes, options);
        }
            function uploadFile(folder, isGlobal, supportedContentTypes, options){
                folder = folder | "";
                return uploadCustomFile(folder, {
                    typeName: "Image",
                    type: "image",
                    typeError: "Picked file isn't image file. Try picking another one."
                }, isGlobal, supportedContentTypes, options);
            }
            function uploadGlobalCustomFile(folder, typeOptions, supportedContentTypes, options){
                return uploadCustomFile(folder, typeOptions, true, supportedContentTypes, options);
            }
            function uploadCustomFile(folder, typeOptions, isGlobal, supportedContentTypes, options){
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'shared/uploadFileModal/addFile.html',
                    controller: 'addFileModal',
                    resolve: {
                        folder: function(){
                            return folder;
                        },
                        typeOptions: function(){
                            return typeOptions;
                        },
                        isGlobal: function(){
                            return isGlobal;
                        },
                        supportedContentTypes: function(){
                            return supportedContentTypes;
                        },
                        options: function(){
                            return options;
                        }
                    }
                });

                return modalInstance.result.then(function (data) {
                    return $q.resolve(data);
                }, function (error) {
                    return $q.reject();
                });
            }

        }]);

})(window.angular);
